import { home_carousel_apis, store_carousel_apis } from '../ApiConst';
import { axiosInstance } from '../axios';
import { buildFormData } from '../../Utils/formDataUtils';
import {
  CreateStoreCarouselPayload,
  GetStoreCarouselListParams,
  HomeCarouselData,
  ReorderStoreCarouselPayload,
  StoreCarouselData,
  UpdateStoreCarouselPayload,
} from './types/carousel.types';
import type { AxiosResponse } from 'axios';


export const CreateStoreCarousel = async (
  payload: CreateStoreCarouselPayload
) => {
  const formData = buildFormData(payload);

  return await axiosInstance.post(store_carousel_apis.create, formData, {
    // @ts-ignore
    useUserToken: true,
    // Overrides the instance's JSON default, which makes axios turn FormData into JSON
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const GetStoreCarouselListForStore = async () => {
  return await GetStoreCarouselList(undefined, true);
};

export const GetStoreCarouselListForStorePublic = async (storeId: string) => {
  return await GetStoreCarouselList(storeId, false);
};

/**
 * Fetches the list of store carousels.
 * @param storeId The storeId is optional. A seller need not send it to fetch their own store's carousels, but a guest must send it to fetch a store's carousels. Seller will get all carousels, while guest will get only active carousels.
 * @param useUserToken This is used because for guest.
 */
export const GetStoreCarouselList = async (storeId?: string, useUserToken: boolean = false) => {
  return await axiosInstance.get<
    StoreCarouselData[],
    AxiosResponse<StoreCarouselData[]>,
    any,
    GetStoreCarouselListParams
  >(store_carousel_apis.list, {
    // @ts-ignore
    useUserToken: useUserToken,

    params: {
      store_id: storeId,
    },
  });
};

export const GetCarouselDetail = async (id: number) => {
  return await axiosInstance.get<StoreCarouselData>(
    store_carousel_apis.detail(id),
    {
      // @ts-ignore
      useUserToken: false,
    }
  );
};

export const UpdateStoreCarousel = async (
  id: number,
  payload: UpdateStoreCarouselPayload
) => {
  const formData = buildFormData(payload);

  return await axiosInstance.patch(store_carousel_apis.update(id), formData, {
    // @ts-ignore
    useUserToken: true,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const ReorderStoreCarousel = async (
  payload: ReorderStoreCarouselPayload
) => {
  return await axiosInstance.post(store_carousel_apis.reorder, payload, {
    // @ts-ignore
    useUserToken: true,
  });
};

export const DeleteStoreCarousel = async (id: number) => {
  return await axiosInstance.delete(store_carousel_apis.delete(id), {
    // @ts-ignore
    useUserToken: true,
  });
};

/**
 * Fetches the active homepage carousels.
 */
export const GetHomeCarouselList = async () => {
  return await axiosInstance.get<HomeCarouselData[]>(
    home_carousel_apis.list,
    {
      // @ts-ignore
      useUserToken: false,
    }
  );
};

